'use client'

import { SVGProps, useEffect } from 'react'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('Error page:', error)
  }, [error])

  return (
    <div className="tw-flex tw-min-h-[100dvh] tw-flex-col tw-items-center tw-justify-center tw-bg-background tw-px-4 tw-py-12 sm:tw-px-6 lg:tw-px-8">
      <div className="tw-mx-auto tw-max-w-md tw-text-center">
        <ServerIcon className="tw-mx-auto tw-h-12 tw-w-12 tw-text-primary" />
        <h1 className="tw-mt-4 tw-text-3xl tw-font-bold tw-tracking-tight tw-text-foreground sm:tw-text-4xl">
          Oops, something went wrong!
        </h1>
        <p className="tw-mt-4 tw-text-muted-foreground">
          We&apos;re sorry, but an unexpected error has occurred on our server. Please try again later or contact
          support if the issue persists.
        </p>
        <div className="tw-mt-6">
          <button className="btn btn__default" onClick={() => reset()}>
            Try again
          </button>
        </div>
      </div>
    </div>
  )
}

function ServerIcon(props: SVGProps<any>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="20" height="8" x="2" y="2" rx="2" ry="2" />
      <rect width="20" height="8" x="2" y="14" rx="2" ry="2" />
      <line x1="6" x2="6.01" y1="6" y2="6" />
      <line x1="6" x2="6.01" y1="18" y2="18" />
    </svg>
  )
}
